module.exports = __webpack_public_path__ + "static/media/ToolImg.e865ed32.png";